import { IApplicationState } from '../../types/redux';
import { getDeveloperRatingById } from './getDeveloperRatingById';

export function getDeveloperRatingDescriptionById(state: IApplicationState, id: number) {
  const rating = getDeveloperRatingById(state, id);

  return rating?.description || null;
}
